import { useEffect } from 'react';

/**
 * A-STAR Workshop 2026 landing page.
 * The page now lives at its own subdomain, so visiting /astar simply
 * redirects there.
 */
const ASTAR_URL = 'https://a-star.spacemap42.com';

const Astar = () => {
  useEffect(() => {
    window.location.replace(ASTAR_URL);
  }, []);

  return null;
};

export default Astar;
